var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    "data-name": "Vrstva 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.86 52.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.11.94h0L52.05.88l0,0,0,0-.05,0h0c-.53-.48-2.6-1.94-6.46,1.12C41,5.4,26.36,18.87,20.23,20.64s-8.91.71-13.49,3.51S-.51,34.87.08,37.47s3.2,6.54,7.4,5.17c3.63-1.17,4.09-2.26,4.54-1.92h0l.06.05,0,.06h0c.34.44-.72.92-1.9,4.55-1.36,4.21,2.58,6.8,5.17,7.4S25.9,50.7,28.7,46.12s1.74-7.37,3.51-13.5S47.47,11.83,51,7.39C54,3.53,52.54,1.41,52.11.94ZM30.7,24.67C27.33,28,24,30.21,23.35,29.52s1.48-4,4.85-7.35,6.66-5.54,7.35-4.85S34.07,21.3,30.7,24.67Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaddle);
export default __webpack_public_path__ + "static/media/saddle.b277fd3485a9b06b9e025e0f11779659.svg";
export { ForwardRef as ReactComponent };